import axios from 'axios'
var MyAxios = {};
MyAxios.install = function(app) {
    const DiaryAxios = axios.create({
        timeout: 5 * 1000,
    });
    const FileAxios = axios.create({
        timeout: 60 * 1000,
    });
    app.config.globalProperties.$myAxios = (that, opt, succ, isfile = false) => {

        var defaultHeader = { "Authorization": that.$cookies.get('username') + "@" + that.$cookies.get('ticket') };
        if (opt.headers) {
            opt.headers = {...opt.headers, ...defaultHeader }
        } else {
            opt.headers = defaultHeader;
        }
        if (!isfile) {
            DiaryAxios(opt)
                .then(function(response) {
                    //console.log(response, response.data);
                    var res = response.data;
                    console.log('API返回数据:', opt.url, res);
                    if (res.status) {
                        if (res.status == 3) {
                            NeedLogin(that, res);
                            return;
                        }
                        if (res.status == 0) {
                            succ(res);
                            //that.$toast(res.msg, 'succ', 2500)
                        } else {
                            that.$toast(res.msg, 'fail')
                            console.log('失败(' + opt.url + ')：', res);
                        }
                    } else {
                        succ(res);
                    }
                })
                .catch(function(error) {
                    Error(that, error)
                });
        } else {
            that.$toast("开始上传...", 'normal', 60 * 1000);
            FileAxios(opt)
                .then(function(response) {
                    //console.log(response, response.data);
                    var res = response.data;
                    if (res.status == 3) {
                        NeedLogin(that, res);
                        return;
                    }
                    if (res.status == 0) {
                        that.$toast(res.msg, 'succ')
                        succ(res);
                    } else {
                        that.$toast(res.msg, 'fail')
                        console.log('失败(' + opt.url + ')：', res);
                    }
                })
                .catch(function(error) {
                    Error(that, error, opt)
                });
        }

        function Error(that, error) {
            that.$toast('网络错误', 'err')
            console.log('出错(' + opt.url + ')：', error);
        }

        function NeedLogin(that, res) {
            that.$toast(res.description, 'fail')
            that.$cookies.set('username', '');
            //保存正在编辑的内容
            sessionStorage.setItem('tempdata-' + that.$options.name, JSON.stringify(that.$data));
            //返回登录页面
            that.$router.push('/Login?f=' + that.$options.name);
        }
    }


}
export default MyAxios;